import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { images } from '../../constants';
import 'aos/dist/aos.css';
import AOS from 'aos';
import { useTranslation, initReactI18next } from "react-i18next";
import i18n from "i18next";
import translationEN from "../../constants/locales/en/translation.json";
import translationID from "../../constants/locales/id/translation.json";

const resources = {
  en: {
    translation: translationEN,
  },
  id: {
    translation: translationID,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem('lang') || 'en',
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export const Header = () => {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({
      once: true,
      disable: 'phone',
      duration: 700,
      easing: 'ease-out-cubic',
    });

    return () => {
      AOS.refresh();
    };
  }, []);

  return (
    <div data-testid= 'header' className='flex flex-col lg:flex-row justify-center p-10 mt-7 min-h-[85vh] relative overflow-auto'>
      <div className='flex w-full lg:w-1/2 flex-col items-center lg:items-start'>
        <div className='lg:ml-11 lg:mt-[3cm] text-center items-center lg:text-left'>
            <h1
                className="font-gelasio font-bold text-[40px] lg:text-[45px] mb-4"
                data-aos="zoom-y-out"
                data-testid="title"
            >
                {t("landing_page_welcome")} <span className="font-bold text-[#2D3494]">Senar</span>
                <span className="text-[#E91D25]">ai</span>!
            </h1>
            <div
                className="lg:hidden text-center"
                data-aos="zoom-y-out"
                data-aos-delay="300"
            >
                <img
                src={images.typing}
                alt="typing_responsive"
                className=" w-98 mx-auto h-auto md:w-96 sm:w-70 mb-4"
                />
            </div>
            <p 
                className='text-[18px] text-black font-lato  text-justify lg:mr-[7cm]'
                data-aos="zoom-y-out"
                data-aos-delay="300"
                data-testid="description"
                >
                <span className="text-[#2D3494] font-extrabold">Senar</span>
                <span className="text-[#E91D25] font-extrabold">ai</span> 
                {t("landing_page_description")}
            </p>
            <p
                className="font-extrabold font-lato text-[17px] text-justify mt-4 mb-2"
                data-aos="zoom-y-out"
                data-aos-delay="300"
                data-testid="demo-text"
            >
                {t("landing_page_try_text")}
            </p>
            <button
                className="bg-[#2D3494] hover:bg-white text-white font-lato hover:text-[#2D3494] hover:border border-[#2D3494] p-4 rounded-xl"
                data-aos="zoom-y-out"
                data-aos-delay="300"
                data-testid="demo-button"
            >
                <Link to="/product-demo" className="flex  font-bold">
                {t("landing_page_try_button")}
                </Link>
            </button>
        </div>
      </div>
      <div className='mt-6 lg:mt-[1.5cm] lg:ml-[2cm] flex flex-col items-center lg:items-start'>
        <div
          className="hidden lg:flex lg:mt-0 "
          data-aos="zoom-y-out"
          data-aos-delay="400"
        >
          <img src={images.typing} alt="typing" className="w-full h-auto md:w-96" />
        </div>
      </div>
    </div>
  );
};
